var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.5C10.3 9.5 9 10.8 9 12.5C9 14.2 10.3 15.5 12 15.5C13.7 15.5 15 14.2 15 12.5C15 10.8 13.7 9.5 12 9.5ZM18 19L19.8 17.2C19.3 16.8 18.7 16.5 18 16.5C16.6 16.5 15.5 17.6 15.5 19C15.5 20.4 16.6 21.5 18 21.5C18.8 21.5 19.5 21.1 20 20.5H21.7C21.1 22 19.7 23 18 23C15.8 23 14 21.2 14 19C14 16.8 15.8 15 18 15C19.1 15 20.1 15.4 20.8 16.2L22 15V19H18ZM12.1 20C7 20 2.7 16.9 1 12.5C2.7 8.1 7 5 12 5C17 5 21.3 8.1 23 12.5C22.8 12.9 22.6 13.4 22.4 13.8C21.3 13 20 12.5 18.5 12.5C18 12.5 17.5 12.6 17 12.7V12.5C17 9.7 14.8 7.5 12 7.5C9.2 7.5 7 9.7 7 12.5C7 15.3 9.2 17.5 12 17.5H12.2C12.1 18 12 18.5 12 19C12 19.3 12 19.7 12.1 20Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeRefresh);
export default __webpack_public_path__ + "static/media/eye-refresh.ff8dc12ffc8cf341c885d09322323820.svg";
export { ForwardRef as ReactComponent };